import { setSpecificMessage, minWords } from "valibot";
setSpecificMessage(
  minWords,
  (issue) => `Mots invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);